import React from 'react'
import AuditImage from "../../../assets/images/audit.svg"

const NoInspection = () => {
  return (
    <div className='emptyState'>
        <img src={AuditImage} alt="" />
        <h4>No Inspections Available</h4>
        <p>Inspections are not submitted by the surveyor yet</p>
    </div>
  )
}

export default NoInspection